import React from 'react';
import BillPositionButton from './BillPositionButton';
import { Bill } from '@enview/interface/types/bills/Bill';
import { PopoverPosition } from 'react-tiny-popover';

interface BillPositionProps {
  bill: Bill;
  showPlaceholderText?: boolean;
  positions?: PopoverPosition[];
  variant?: 'compact' | 'pill';
}

export const BillPosition: React.FC<BillPositionProps> = ({
  bill,
  showPlaceholderText,
  positions,
  variant,
}) => {
  return (
    <div
      className="bp-button-wrapper"
      onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
    >
      <BillPositionButton
        bill={bill}
        positions={positions}
        showPlaceholderText={showPlaceholderText}
        variant={variant}
      />
    </div>
  );
};

export default BillPosition;
